import { render } from "./SustainableWhatToDoSection.vue?vue&type=template&id=3d6f416c&scoped=true"
import script from "./SustainableWhatToDoSection.vue?vue&type=script&lang=js"
export * from "./SustainableWhatToDoSection.vue?vue&type=script&lang=js"

import "./SustainableWhatToDoSection.vue?vue&type=style&index=0&id=3d6f416c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6f416c"]])

export default __exports__